const browserProtocol =
  typeof window !== "undefined" && window.location.protocol
    ? window.location.protocol
    : "http:";
const browserHostname =
  typeof window !== "undefined" && window.location.hostname
    ? window.location.hostname
    : "localhost";
const browserPort =
  typeof window !== "undefined" && window.location.port
    ? window.location.port
    : "";
const browserOrigin =
  typeof window !== "undefined" && window.location.origin
    ? window.location.origin
    : `${browserProtocol}//${browserHostname}${
        browserPort ? `:${browserPort}` : ""
      }`;

const isLocalhost =
  browserHostname === "localhost" ||
  browserHostname === "127.0.0.1" ||
  browserHostname === "0.0.0.0";

let frontendOrigin = browserOrigin;
let backendOrigin = browserOrigin;

// Only append local dev/docker ports when running on localhost with explicit development ports
if (isLocalhost) {
  if (browserPort === "10181") {
    frontendOrigin = `${browserProtocol}//${browserHostname}:10181`;
    backendOrigin = `${browserProtocol}//${browserHostname}:10182`;
  } else if (browserPort === "3000") {
    frontendOrigin = `${browserProtocol}//${browserHostname}:3000`;
    backendOrigin = `${browserProtocol}//${browserHostname}:10182`;
  } else if (browserPort) {
    frontendOrigin = `${browserProtocol}//${browserHostname}:${browserPort}`;
    backendOrigin = `${browserProtocol}//${browserHostname}:10182`;
  }
}

// Allow environment variable overrides if provided at build/runtime
const envApiUrl = process.env.REACT_APP_API_BASE_URL;
const envBackendUrl = process.env.REACT_APP_BACKEND_URL;
const envFrontendUrl = process.env.REACT_APP_FRONTEND_URL;

if (envBackendUrl) {
  backendOrigin = envBackendUrl.replace(/\/+$/, "");
}
if (envFrontendUrl) {
  frontendOrigin = envFrontendUrl.replace(/\/+$/, "");
}

const resolvedBaseURL = envApiUrl
  ? envApiUrl.endsWith("/")
    ? envApiUrl
    : `${envApiUrl}/`
  : `${backendOrigin}/api/`;
const resolvedSocketUrl = envBackendUrl
  ? envBackendUrl.endsWith("/")
    ? envBackendUrl
    : `${envBackendUrl}/`
  : `${backendOrigin}/`;

export const appConstants = {
  baseURL: resolvedBaseURL,
  socketUrl: resolvedSocketUrl,
  loginURL: `${frontendOrigin}/login`,
  frontendURL: `${frontendOrigin}/`,
  loginPath: "/login",

  // ----------Common-------------
  googleAutoCommpleteKey: "AIzaSyCNe-x9Jn_2903j9PxhLPw6SPGXMwIlkCM",
  privateKey: "PfngA5S5H5",
  maxRecordsFetchCount: 10,
  SIGNATURE_KEY: "RA169",
  version: 1.0,
  userStatus: "Pending",
  page: 1,
  limit: 10,
};
